import { cn } from '../../lib/utils'
import { CardContent, CardSubHeader, Button } from '../ui'
import { ChevronLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function SubNavBar({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <CardSubHeader className={cn('px-4 py-4 h-auto md:px-4 md:py-4 rounded-3xl', className)}>
      <CardContent className="p-0">
        <div className="flex items-center justify-between flex-wrap md:flex-nowrap gap-4 md:gap-0">
          {children}
        </div>
      </CardContent>
    </CardSubHeader>
  )
}

export function SubNavBarLeft({
  children,
  title,
  allowWrap = false,
  hideBack = false,
  className,
}: {
  children?: React.ReactNode
  title?: string
  allowWrap?: boolean
  hideBack?: boolean
  className?: string
}) {
  const navigate = useNavigate()
  return (
    <div className={cn('flex items-center gap-2 md:gap-4', allowWrap && 'flex-wrap')}>
      {!hideBack && (
        <Button
          variant="main_action"
          onClick={() => navigate(-1)}
          className="flex items-center gap-0 md:gap-1 rounded-full h-7 md:h-9"
        >
          <ChevronLeft className="h-3 w-3 md:h-4 md:w-4" />
          <span className="text-xs md:text-base">Back</span>
        </Button>
      )}
      <div className={cn('flex items-center gap-2 md:gap-4 flex-wrap', className)}>
        {title && <h1 className="text-lg md:text-2xl font-bold">{title || ''}</h1>}
        {children || null}
      </div>
    </div>
  )
}

export function SubNavBarRight({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={cn('flex items-center gap-2 md:gap-4', className)}>{children}</div>
}
